import { Component, OnInit, ViewChild } from '@angular/core';
import { stagger60ms } from '../../../@vex/animations/stagger.animation';
import { fadeInUp400ms } from '../../../@vex/animations/fade-in-up.animation';
import { UserStore } from '../../stores/user.store';
import { ApiService } from '../../services/api.service';
import icMail from '@iconify/icons-ic/twotone-mail';
import icChat from '@iconify/icons-ic/twotone-chat';
import icGroup from '@iconify/icons-ic/twotone-group';
import { TreeComponent, TreeModel } from '@circlon/angular-tree-component';

export interface Team {
  id: number;
  visibility: string;
  displayName: string;
  mail: string;
  description: string;
  createdDateTime: Date;
}

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss'],
  animations: [
    stagger60ms,
    fadeInUp400ms
  ]
})
export class TeamsComponent implements OnInit {
  teams: any;
  filteredTeams: any;

  icMail = icMail;
  icChat = icChat;
  icGroup = icGroup;

  @ViewChild(TreeComponent)
  private tree: TreeComponent;
  options = {};
  nodes = [];

  constructor(private userStore: UserStore, private apiService: ApiService) { }

  async ngOnInit() {
    this.teams = await this.apiService.get("graph/teams");
	  this.filteredTeams = JSON.parse(JSON.stringify(this.teams));
    this.nodes = this.buildNotes(this.teams);
    this.tree.treeModel.update();
  }

  filterFn(value: string, treeModel: TreeModel) {
    var srch = value.toLowerCase();
    treeModel.filterNodes((node) => {
      return node.data.searchField.toLowerCase().indexOf(srch) > -1;
    });
    this.filteredTeams = this.teams.filter(r => r.displayName.toLowerCase().indexOf(srch) > -1);
  }

  treeSelected($event: any) {
    // this.resetFilter();
    const children = $event.node.data.children;
    const ids = [$event.node.data.id, ...$event.node.data.children.map(c => c.id)];
    this.filteredTeams = this.teams.filter(r => ids.includes(r.id));
  }

  resetFilter() {
	  this.tree.treeModel.clearFilter();
	  this.filteredTeams = JSON.parse(JSON.stringify(this.teams));
  }

  sendMail(team: Team) {
    window.open("mailto:" + team.mail, "_blank");
  }

  async openTeamsLink(team: Team) {
    const channels = await this.apiService.get("graph/teams/" + team.id + "/channel") as [];
    // @ts-ignore
    window.open("https://teams.microsoft.com/l/team/" + channels[0].id + "/conversations", "_blank");
  }

  buildNotes(teams: [any]) {
    const tempNodes = [];
    teams.forEach(item => {
      if (item.displayName.indexOf('.') > 0) { // if name contains "."
        const parentName = item.displayName.toUpperCase().substr(0, item.displayName.indexOf('.'));

        let parentNode: { children: any[]; name: string; id: string, isExpanded: boolean, description: string, visibility: string; iconUrl: string, searchField: string };
        if (tempNodes.find(x => x.id === parentName)) {
          parentNode = tempNodes.find(x => x.id === parentName);
        }
        else {
          parentNode = {
            id: parentName,
            name: parentName,
            isExpanded: true,
            children: [],
            description: item.description,
            visibility: item.visibility,
            iconUrl: './assets/logos/customers/' + parentName + ".png",
  		  	searchField: item.displayName
          };
        }
        const childName = item.displayName.substr(item.displayName.indexOf('.') + 1);
        const childNode = {
          id: item.id,
          name: childName,
          isExpanded: false,
          children: [],
          description: item.description,
          visibility: item.visibility,
          iconUrl: null,
		  searchField: item.displayName
        };
        parentNode.children.push(childNode);
        if (!tempNodes.find(x => x.id === parentName)) {
          tempNodes.push(parentNode);
        }
      } else {
        const elem = {
          id: item.id,
          name: item.displayName,
          isExpanded: true,
          children: [],
          description: item.description,
          visibility: item.visibility,
          iconUrl: null,
		  searchField: item.displayName
        };
        tempNodes.push(elem);
      }
    });
    return tempNodes;
  }
}
